module.exports = __webpack_public_path__ + "img/logo-atlassian.3dc00559.svg";